import { api } from "./api";

const visitorId = () => {
  let v = localStorage.getItem("sw_vid");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("sw_vid", v); }
  return v;
};

export const trackVideo = (n, type) =>
  api.post("/videos/event", { n, type, vid: visitorId(), sid: localStorage.getItem("sw_chat_sid") || "" }).catch(() => {});
